import { useTranslation } from 'react-i18next';
import styles from './time-column.module.css';

type Properties = {
  date: Date;
};

const TimeColumn = ({ date }: Properties) => {
  const { t } = useTranslation(['translationReactComponents']);

  return (
    <div className={styles['time-col']}>
      <span className={styles['time-text']}>{t('dateFormats.time', { date })}</span>
    </div>
  );
};

export default TimeColumn;
